import { saveAs } from 'file-saver';
import api from './api';

export const downloadBillingCycles = async filters => {
  const blob = await api.OrganizationBilling.download('cycles/export', filters);
  saveAs(blob, 'organization-billing-cycles.xlsx');
};

export const downloadBillingInvoice = async guid => {
  const blob = await api.OrganizationBilling.download(
    `invoices/${encodeURIComponent(guid)}/pdf`
  );
  saveAs(blob, 'organization-invoice.pdf');
};
